interface ControlData {
  sensitivity?: number;
  [key: string]: any;
}

interface TestData {
  Test: string;
}

const updateFunc = (controlData: ControlData): TestData[] => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;

  const tp = sensitivity;
  const fn = 100 - sensitivity;
  const bl = 900;

  const jsonTruePositive: TestData = { Test: "True positive" };
  const jsonFalseNegative: TestData = { Test: "False negative" };
  const jsonBlank: TestData = { Test: "" };
  const repeatedTruePositive = Array(tp).fill(jsonTruePositive);
  const repeatedFalseNegative = Array(fn).fill(jsonFalseNegative);
  const repeatedBlank = Array(bl).fill(jsonBlank);
  const calculatedData1 = repeatedTruePositive.concat(repeatedFalseNegative);
  const calculatedData = calculatedData1.concat(repeatedBlank);

  return calculatedData;
};

export default updateFunc;
